module.exports = __webpack_public_path__ + "img/5-01.29635161.png";